import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  ExportButton,
  Filter,
  EditButton,
  CreateButton,
  required,
} from 'react-admin';
const CodeFilter = (props) => (
  <Filter {...props}>
      <TextInput label="Level" source="level" alwaysOn />
  </Filter>
);

const LanguageLevelActions = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    currentSort,
    total,
    exporter,
    basePath,
  } = props;

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={total}
      />
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const LanguageLevelList = props => (
  <List {...props} filters={<CodeFilter/>} actions={<LanguageLevelActions props={props} />}>
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <TextField label="Түвшин" source="level" />
      <EditButton />
    </Datagrid>
  </List>
);

const LanguageLevelTitle = ({ record }) => {
  return <span>LanguageLevel {record ? `"${record.level}"` : ''}</span>;
};

export const LanguageLevelEdit = props => (
  <Edit title={<LanguageLevelTitle />} {...props}>
    <SimpleForm>
      <TextField label="ID" source="id" />
      <TextInput label="Түвшин" source="level" validate={[required()]} />
    </SimpleForm>
  </Edit>
);

export const LanguageLevelCreate = props => (
  <Create {...props}>
    <SimpleForm>
        <TextField label="ID" source="id" />
      <TextInput label="Түвшин" source="level" validate={[required()]} />
    </SimpleForm>
  </Create>
);